import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const API = import.meta.env.VITE_API_URL || ''
const SUPER_ADMIN = 'pvluca@gmail.com'

interface UserRow {
  company_id: number
  company_name: string
  email: string
  name: string
  plan: string
  plan_expires_at: string | null
  bekas_pack: boolean
  bekas_pack_expires_at: string | null
  created_at: string | null
}

export default function AdminPage() {
  const navigate = useNavigate()
  const [users, setUsers] = useState<UserRow[]>([])
  const [loading, setLoading] = useState(true)
  const [activating, setActivating] = useState<number | null>(null)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) { navigate('/login'); return }

    fetch(`${API}/admin-api/users`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        if (r.status === 403) { navigate('/receptek'); return null }
        return r.json()
      })
      .then(data => { if (data) setUsers(data) })
      .finally(() => setLoading(false))
  }, [])

  const activatePro = async (companyId: number) => {
    const token = localStorage.getItem('token')
    setActivating(companyId)
    await fetch(`${API}/admin-api/activate-pro/${companyId}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    })
    const res = await fetch(`${API}/admin-api/users`, { headers: { Authorization: `Bearer ${token}` } })
    setUsers(await res.json())
    setActivating(null)
  }

  const fmt = (iso: string | null) => iso ? new Date(iso).toLocaleDateString('hu-HU') : '—'

  if (loading) return <div className="p-8 text-gray-500">Betöltés...</div>

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Admin — Felhasználók</h1>
      <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left font-semibold text-gray-600">Cég</th>
              <th className="px-4 py-3 text-left font-semibold text-gray-600">Email</th>
              <th className="px-4 py-3 text-left font-semibold text-gray-600">Csomag</th>
              <th className="px-4 py-3 text-left font-semibold text-gray-600">Lejár</th>
              <th className="px-4 py-3 text-left font-semibold text-gray-600">Békás</th>
              <th className="px-4 py-3 text-left font-semibold text-gray-600">Regisztrált</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {users.map(u => (
              <tr key={u.company_id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium text-gray-900">{u.company_name}</td>
                <td className="px-4 py-3 text-gray-600">{u.email}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                    u.plan === 'pro' ? 'bg-green-100 text-green-700' :
                    u.plan === 'starter' ? 'bg-blue-100 text-blue-700' :
                    'bg-gray-100 text-gray-500'
                  }`}>{u.plan}</span>
                </td>
                <td className="px-4 py-3 text-gray-600">{fmt(u.plan_expires_at)}</td>
                <td className="px-4 py-3">
                  {u.bekas_pack
                    ? <span className="text-green-600 font-semibold">✓ {fmt(u.bekas_pack_expires_at)}</span>
                    : <span className="text-gray-400">—</span>}
                </td>
                <td className="px-4 py-3 text-gray-500">{fmt(u.created_at)}</td>
                <td className="px-4 py-3">
                  {u.plan !== 'pro' && (
                    <button
                      onClick={() => activatePro(u.company_id)}
                      disabled={activating === u.company_id}
                      className="px-3 py-1.5 bg-green-600 text-white text-xs font-semibold rounded-lg hover:bg-green-700 disabled:opacity-50"
                    >
                      {activating === u.company_id ? '...' : 'Pro + Békás (6 hó)'}
                    </button>
                  )}
                  {u.plan === 'pro' && (
                    <span className="text-green-600 text-xs font-semibold">✓ Aktív</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
